import { render, staticRenderFns } from "./ModalAddProduct.vue?vue&type=template&id=41adf354"
import script from "./ModalAddProduct.vue?vue&type=script&lang=js"
export * from "./ModalAddProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProduct.vue?vue&type=style&index=0&id=41adf354&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41adf354')) {
      api.createRecord('41adf354', component.options)
    } else {
      api.reload('41adf354', component.options)
    }
    module.hot.accept("./ModalAddProduct.vue?vue&type=template&id=41adf354", function () {
      api.rerender('41adf354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/ModalAddProduct.vue"
export default component.exports